module.exports = __webpack_public_path__ + "img/c2.c67f1839.jpg";